export function userValidate(user){
    var result = true;
    console.log(user)

    result = validateId(user.id);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}
